module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'ar8689z5',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
